const navButton = document.getElementById('mobile-menu-button');
const mobileMenuOverlay = document.getElementById('menu__mobile-overlay');
const body = document.getElementById('body');
const html = document.getElementsByTagName('html');

navButton.addEventListener('click', () => {
  body.classList.toggle('hide-overflow');
  html[0].classList.toggle('hide-overflow');
  navButton.classList.add('animate');
  navButton.classList.toggle('exit');

  if(mobileMenuOverlay.classList.contains('show')) {
    mobileMenuOverlay.classList.add('hide')
    mobileMenuOverlay.classList.remove('show')
  } else  {
    mobileMenuOverlay.classList.add('show')
    mobileMenuOverlay.classList.remove('hide')
  }
});
